/**
 * Checks if a value is empty. Supports arrays, strings, objects, Maps, and Sets.
 * Returns true for null, undefined, empty strings, empty arrays, empty objects,
 * empty Maps, and empty Sets.
 */
export default function isEmpty(
  value: unknown
): value is null | undefined | '' | never[] | Record<string, never> {
  if (value == null) {
    return true
  }
  if (typeof value === 'string' || Array.isArray(value)) {
    return value.length === 0
  }
  if (value instanceof Map || value instanceof Set) {
    return value.size === 0
  }
  if (typeof value === 'object') {
    return Object.keys(value).length === 0
  }
  return false
}
